import { getCore } from '../../../client/core/getCore';
import { getDefaultClient } from '../../../client/defaultClient';
import type { WalletAccount } from '../walletAccount';
import { getWalletAccountsFromState } from './getWalletAccountsFromState';

/**
 * Retrieves all wallet accounts associated with the current session.
 *
 * This function returns both verified and unverified wallet accounts,
 * combining data from user credentials and local unverified accounts.
 * You can differentiate between verified and unverified wallet accounts by
 * checking the `verifiedCredentialId` property.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns An array of wallet accounts associated with the session.
 */
export const getWalletAccounts = (
  client = getDefaultClient()
): WalletAccount[] => {
  const core = getCore(client);
  const { unverifiedWalletAccounts, user } = core.state.get();

  return getWalletAccountsFromState({ unverifiedWalletAccounts, user }, client);
};
